export const get = async url => {
    const result = await fetch(url)
    return await result.json()
}

export const getStatusApi = () => get('https://api.makerburn.com/ajna/general')
export const getHistoryApi = () => get('https://api.makerburn.com/ajna/history')